import graphReactor from '@/graphReactor';

function ExploreToDendro(id) {
  // const exploreData = graphReactor.exploreInstance.save();
  // const neighbors = graphReactor.exploreInstance.getNeighbors('British Raj', 'source');
  const total = graphReactor.exploreInstance.getNodeDegree(id, 'total');
  const outD = graphReactor.exploreInstance.getNodeDegree(id, 'out');
  const inD = graphReactor.exploreInstance.getNodeDegree(id, 'in');

  console.log(`total#out#in - ${id} [${total}] - [${outD}] -[${inD}]`);

  if (total > 0 && outD > 0) {
    console.log(`Test Passed # ${id}`);
  }
}

export default ExploreToDendro;
